/** Статусы PayKeeper: ключи API → подписи как в ЛК PayKeeper */
export const PAYKEEPER_STATUS_LABELS = {
    success: 'Совершён',
    canceled: 'Отменён',
    refunded: 'Возвращён клиенту',
    failed: 'Не состоялся',
    obtained: 'Получен',
    obtain: 'Получен', // алиас PayKeeper, в UI не дублируем
    refunding: 'Инициирован возврат',
    partially_refunded: 'Частично возвращён клиенту',
    stuck: 'Совершён без оповещения',
    pending: 'Ожидает оплаты',
};

/** Уникальные опции для фильтров (без дубля obtain/obtained) */
export const PAYKEEPER_STATUS_OPTIONS = [
    { value: 'success', label: 'Совершён' },
    { value: 'canceled', label: 'Отменён' },
    { value: 'refunded', label: 'Возвращён клиенту' },
    { value: 'failed', label: 'Не состоялся' },
    { value: 'obtained', label: 'Получен' },
    { value: 'refunding', label: 'Инициирован возврат' },
    { value: 'partially_refunded', label: 'Частично возвращён клиенту' },
    { value: 'stuck', label: 'Совершён без оповещения' },
    { value: 'pending', label: 'Ожидает оплаты' },
];

/** При фильтре «Получен» учитываем оба ключа API */
export function expandPaykeeperStatusFilter(statuses) {
    const list = Array.isArray(statuses) ? statuses : (statuses ? [statuses] : []);
    const out = new Set();
    for (const s of list) {
        if (!s) continue;
        out.add(s);
        if (s === 'obtained' || s === 'obtain') {
            out.add('obtained');
            out.add('obtain');
        }
    }
    return [...out];
}

export function labelPaykeeperStatus(status) {
    if (status == null || status === '') return '—';
    return PAYKEEPER_STATUS_LABELS[status] || status;
}
